import { FC, lazy } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { Heading } from 'src/components/heading';
import { MessageBox } from 'src/components/message-box';
import { ThrowNotFound } from 'src/components/not-found';
import { Stack } from 'src/components/stack';
import { CorrectionsOverview } from 'src/pages/reporting/monthly-statements/corrections';
import { CreateMonthlyStatement } from 'src/pages/reporting/monthly-statements/create';
import { CurtailmentsOverview } from 'src/pages/reporting/monthly-statements/curtailments';
import { EditMonthlyStatement } from 'src/pages/reporting/monthly-statements/edit';
import { MonthlyStatementsOverview } from 'src/pages/reporting/monthly-statements/overview';
import { useMonthlyStatements } from 'src/pages/reporting/monthly-statements/overview/use-monthly-statements';
import { useCapacityManagementRoot } from 'src/pages/transport/network-points/details/availability-and-price-data/overview/use-capacity-management-root';

export const MonthlyStatements: FC = () => {
  const capacityManagementRoot = useCapacityManagementRoot();

  // share this resource across sub-pages, so it is not unnecessary re-fetchted,
  // but every page takes care of fetching it initially individually (because
  // the initial params might differ and _some_ sub-pages might not need it)
  const monthlyStatements = useMonthlyStatements();

  if (monthlyStatements.error)
    return (
      <Stack gap={2}>
        <Heading mode="title">Monthly Statements</Heading>

        <MessageBox type="warning">
          Monthly Statements can only be used, if you are using the PRISMA
          capacity management service.
        </MessageBox>
      </Stack>
    );

  return (
    <Switch>
      <Redirect
        path="/reporting/monthly-statements"
        exact
        to="/reporting/monthly-statements/overview"
      />

      <Route path="/reporting/monthly-statements/overview">
        <MonthlyStatementsOverview
          capacityManagementRoot={capacityManagementRoot}
          monthlyStatements={monthlyStatements}
        />
      </Route>

      <Route path="/reporting/monthly-statements/corrections">
        <CorrectionsOverview capacityManagementRoot={capacityManagementRoot} />
      </Route>

      <Route path="/reporting/monthly-statements/curtailments">
        <CurtailmentsOverview capacityManagementRoot={capacityManagementRoot} />
      </Route>

      <Route path="/reporting/monthly-statements/create">
        <CreateMonthlyStatement
          capacityManagementRoot={capacityManagementRoot}
          monthlyStatements={monthlyStatements}
        />
      </Route>

      <Route path="/reporting/monthly-statements/:monthlyStatementId/edit">
        <EditMonthlyStatement
          capacityManagementRoot={capacityManagementRoot}
          monthlyStatements={monthlyStatements}
        />
      </Route>

      <Route>
        <ThrowNotFound />
      </Route>
    </Switch>
  );
};
